module.exports = __webpack_public_path__ + "static/media/iconRefresh2.61fc21b1.svg";